/* eslint-disable react/jsx-no-undef */
import React from 'react';
import classNames from 'classnames';
import Text from '@zvuk-b2b/react-uikit/ui/Text';
import DateUtils from '@zvuk-b2b/react-uikit/toolkit/DateUtils';
import DeclensionUtils from 'application/utils/DeclensionUtils';
import VideoStreamPreviewItemPoster from '../VideoStreamPreviewItemPoster';

import styles from './index.module.scss';
import { TEXTS } from '../../texts';

interface VideoStreamPreviewItemContentProps {
  title?: string | null;
  description?: string | null;
  previewUrl?: string;
  duration?: number | null;
  filesCount?: number;
}

const VideoStreamPreviewItemContent: React.FC<VideoStreamPreviewItemContentProps> = ({
  title,
  description,
  previewUrl,
  duration,
  filesCount,
}) => (
  <div className={styles.VideoStreamPreviewItemContent}>
    <div className={styles.VideoStreamPreviewItemContentPosterContainer}>
      <VideoStreamPreviewItemPoster
        title={title}
        previewUrl={previewUrl}
      />
    </div>

    <div className={styles.VideoStreamPreviewItemContentTextContainer}>
      <h4
        className={classNames(styles.VideoStreamPreviewItemContentTextContainerTitle, {
          [styles.VideoStreamPreviewItemContentTextContainerTitleLong]: !description,
        })}>
        {title}
      </h4>
      {description && <p className={styles.VideoStreamPreviewItemContentTextContainerDescription}>{description}</p>}
      <div className={styles.info}>
        {Boolean(duration) && (
          <Text elementId="video_stream_duration">{duration && DateUtils.durationToShortString(duration)}</Text>
        )}
        <Text elementId="files_count">
          {`${filesCount}  ${DeclensionUtils.wordMorphByNumber(Number(filesCount), TEXTS.FILE_FORMS)}`}
        </Text>
      </div>
    </div>
  </div>
);

export default VideoStreamPreviewItemContent;
